const en = {
  used: 'Used',
  use: 'Reusable use',
  mixedUsage: 'Consumption and reusable use',
  useCount: 'uses',
  itemTypeChanged: 'The item type changed. Reopen the wizard and check the selection.',
  invalidReusableUse: 'Mark reusable equipment as Used once per operation.',
  dateSignal_unknown: 'Some stock has an unknown date',
  dateSignal_warning: 'Expiry or review due within 3 months',
  dateSignal_critical: 'Expiry or review overdue or due within 1 month',
  taskPageHint: 'Assign work, track deadlines and review warehouse alerts.',
  taskFilterStore: 'Warehouse filter',
  taskAllStores: 'All warehouses',
  taskChooseStore: 'Choose a warehouse',
  taskSearchChoice: 'Search: %s',
  taskSearchPlaceholder: 'Search…',
  taskMineShort: 'Mine',
  taskNoResults: 'No matching results.',
  taskListFilter: 'Status',
  taskOpen: 'Open',
  taskClosed: 'Closed',
  taskAll: 'All',
  taskUnread: 'Unread',
  taskResults: 'Results',
  taskSearchTasks: 'Search tasks or warehouses',
  taskYou: 'You',
  taskAssignedUser: 'Assigned user',
  taskNoTasks: 'No tasks in this view',
  taskNoTasksHint: 'Change the filters or create a new task.',
  taskNoTasksUserHint: 'Change the filters or wait for a task to be assigned.',
  taskRecurring: 'Recurring tasks',
  taskEveryDays: 'Interval in days',
  taskShowMore: 'Show more',
  taskNotificationsHint:
    'Alerts are grouped by warehouse or task. Expand a row to review the details.',
  taskNotificationCount: 'Notifications',
  taskOtherNotifications: 'Other notifications',
  taskMissingDates: 'Missing dates',
  taskUpcomingDates: 'Upcoming dates',
  taskOpenStore: 'Open warehouse',
  taskOpenTask: 'Open task',
  taskMarkGroupRead: 'Mark group as read',
  taskNoNotifications: 'No notifications to review',
  taskNoNotificationsHint:
    'You are up to date. Read notifications are available under All.',
  taskPushSettings: 'Notifications on this device',
  taskPushHint: 'Manage push notifications for this browser or device.',
  taskPushDisabled: 'Push notifications disabled on this device.',
  taskAlertSettings: 'Warehouse alert thresholds',
  taskThresholdHint:
    'Days before the deadline, separated by commas, e.g. 90,30,7.',
  taskDetails: 'Task details',
  taskFormHint:
    'Choose the task type, warehouse and person responsible. For a stocktake, also specify its scope.',
  taskDescriptionOptional: 'Description (optional)',
  taskSchedule: 'Schedule and responsibility',
  taskRepeat: 'Repeat this task',
  taskRepeatHint: 'Create the next task after completion.',
  taskRecurringHint:
    'The interval runs from completion. Each occurrence is assigned separately.',
  taskWholeStore: 'Entire warehouse',
  taskSelectedCategories: 'Selected categories',
  taskWholeStoreHint:
    'Count all products in this warehouse, including zero stock.',
  taskCategoryHint:
    'Selecting a category includes its subcategories. Linked rows are already included.',
  taskSearchCategories: 'Search categories',
  taskScopeCount: 'Selected branches',
  taskCreate: 'Create task',
  taskCreated: 'Task created.',
  taskStoreRequired: 'Choose a warehouse for this task.',
  taskTitleRequired: 'Enter a task title.',
  taskDueRequired: 'Enter a valid due date.',
  taskIntervalInvalid: 'Enter a whole number of days between 1 and 3650.',
  taskScopeRequired:
    'Select at least one category or choose the entire warehouse.',
  taskAssigneeRequired: 'Choose an eligible person.',
  taskChooseAssignee: 'Choose a person',
  taskPerformCount: 'Perform stocktake',
  taskWizardHintShort:
    'Open the inventory wizard for this warehouse and task scope.',
  taskManagement: 'Manage task',
  taskSaveDate: 'Save due date',
  taskCancelHint:
    'Cancel this task? It will no longer be available for completion.',
  taskClosedHint: 'This task is closed.',
  year: 'Year',
  month: 'Month',
  unknownDates: 'Unknown',
  addDate: 'Add date',
  monthEnd: 'Dates are valid through the last day of the selected month.',
  increase: 'Increase',
  decrease: 'Decrease',
  showDates: 'Show date quantities',
  hideDates: 'Hide date quantities',
  expirySetting: 'Expiry date',
  categoryTrackingHint:
    'Applies to all subcategories and products, including those added later.',
  inheritedTracking: 'Enabled by a parent category.',
  reviewSetting: 'Review date',
  searchCaretakers: 'Search store caretakers',
  pushConfigMissing:
    'Web push is not configured. Ask the administrator to set the VAPID key.',
  pushPermissionTimeout:
    'The permission prompt did not finish. Check your browser notification settings and try again.',
  pushWorkerTimeout:
    'The notification worker could not activate. Refresh the app, check your connection and try again.',
  pushTokenTimeout:
    'Firebase did not provide a push token in time. Check your connection and try again.',
  pushSaveTimeout: 'The device registration did not finish. Try again.',
  pushEnabled: 'Push notifications are enabled on this browser.',
  pushProgress_permission: 'Waiting for browser permission…',
  pushProgress_worker: 'Preparing notification worker…',
  pushProgress_token: 'Registering with Firebase Messaging…',
  pushProgress_saving: 'Saving notification settings…',
  nearestDate: 'Nearest recorded date',
  datesAndBatches: 'Dates and batches',
  theoretical:
    'Recorded quantities by date are theoretical. Verify the physical stock during stocktaking.',
  clearDate: 'Clear date (unknown)',
  removeBatch: 'Remove batch',
  fefoHint:
    'Automatic selection uses unknown dates first, then the earliest expiry/review dates. Choose actual quantities if different.',
  countInWizard: 'Stocktake / correct dates in wizard',
  batchTotalMismatch:
    'Batch quantities must equal the product quantity. Expand Dates and batches to correct the count.',
  taskWizardHint:
    'Task stocktaking: verify every product in the assigned scope.',
  storeDateSettings: 'Expiry alerts and store caretakers',
  trackingHint: 'Alert tracking applies to this product in all stores.',
  date: 'Operation date',
  time: 'Time',
  actionNumber: 'Action number',
  actionRequired:
    'An action number in INT/INT/INT format is required for this equipment.',
  onlyMine: 'My tasks only',
  daysSince: 'Days since completion',
  reissue: 'Reissue task',
  batchManaged: 'Batch details are available in the usage wizard.',
  type: 'Type',
  mode: 'Batch selection',
  title: 'Tasks',
  tasks: 'Tasks',
  batches: 'Batches',
  notifications: 'Notifications',
  settings: 'Settings',
  newTask: 'New task',
  titleLabel: 'Title',
  description: 'Description',
  store: 'Store',
  assignee: 'Assignee',
  unassigned: 'Unassigned',
  assigned: 'Assigned',
  in_progress: 'In progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
  stocktaking: 'Stocktaking',
  general: 'General',
  dueOn: 'Due date',
  interval: 'Repeat after completion (days; 0 = once)',
  scope: 'Categories',
  allCategories: 'Entire store',
  result: 'Result / reason',
  start: 'Start',
  complete: 'Complete',
  assign: 'Assign',
  cancelTask: 'Cancel task',
  refreshCount: 'Check conflicts',
  saveDraft: 'Save draft',
  checked: 'Verified',
  quantity: 'Quantity',
  expiresOn: 'Expiry date',
  reviewOn: 'Review date',
  addBatch: 'Add batch',
  unknown: 'Unknown batch',
  fefo: 'FEFO',
  manual: 'Select batches',
  take: 'Take',
  add: 'Receive',
  transfer: 'Transfer',
  withdraw: 'Withdraw',
  equipment: 'Equipment',
  destination: 'Destination',
  newMovement: 'Stock movement',
  save: 'Save',
  close: 'Close',
  refresh: 'Refresh',
  error: 'Operation failed',
  empty: 'No records',
  loading: 'Loading',
  overdue: 'Overdue',
  unresolved: 'Unresolved quantity',
  addUnknownDates: 'Add quantity with unknown date',
  unknownWarning:
    'Unspecified batch: remaining expiry quantities will be uncertain.',
  correct: 'Correct dates',
  resolve: 'Resolve movement',
  initialize: 'Initialize batches',
  preview: 'Check migration',
  legacy: 'Legacy stock',
  migrationReady: 'Migration check passed',
  confirmMigration: 'Create batches from existing stock?',
  caretakers: 'Store caretakers',
  thresholds: 'Alert thresholds (days, comma-separated)',
  trackingExpiry: 'Track expiry dates',
  trackingReview: 'Track review dates',
  enablePush: 'Enable push',
  disablePush: 'Disable push',
  markRead: 'Mark as read',
  read: 'Read',
  active: 'Active',
  lastCompleted: 'Last completed',
  nextDue: 'Next due',
  never: 'Never',
  disableTemplate: 'Disable repetition',
  noAccess: 'No access',
  conflict:
    'Stock changed. Close and reopen the count, then verify the items again.',
  checkAll: 'Verify every product before completion.',
  saved: 'Saved',
  missing: 'Complete all required fields.',
  split: 'Scope is too large. Split it into smaller category tasks.',
  pushDenied: 'Push permission or platform configuration unavailable.',
  reasonRequired: 'A result / reason is required.',
  selectBatch: 'Select batches or use unknown batch.',
  initializeFirst:
    'An administrator must initialize batches for this store first.',
  stockLow: 'Insufficient stock.',
  draftsWarning:
    'Refresh keeps unchanged rows and resets verification for changed stock.',
};
export type OperationsTranslations = { [K in keyof typeof en]: string };
const pl: OperationsTranslations = {
  used: 'Użyto',
  use: 'Użycie wielorazowego',
  mixedUsage: 'Zużycie i użycie',
  useCount: 'użyć',
  itemTypeChanged: 'Typ przedmiotu zmienił się. Otwórz kreator ponownie i sprawdź wybór.',
  invalidReusableUse: 'Przedmiot wielorazowy zaznacz jako Użyto raz w jednej operacji.',
  dateSignal_unknown: 'Część ilości ma nieokreślony termin',
  dateSignal_warning: 'Ważność lub przegląd w ciągu 3 miesięcy',
  dateSignal_critical: 'Ważność lub przegląd w ciągu miesiąca albo po terminie',
  taskPageHint:
    'Zlecaj pracę, kontroluj terminy i sprawdzaj alerty magazynowe.',
  taskFilterStore: 'Filtr magazynu',
  taskAllStores: 'Wszystkie magazyny',
  taskChooseStore: 'Wybierz magazyn',
  taskSearchChoice: 'Szukaj: %s',
  taskSearchPlaceholder: 'Szukaj…',
  taskMineShort: 'Moje',
  taskNoResults: 'Brak pasujących wyników.',
  taskListFilter: 'Status',
  taskOpen: 'Otwarte',
  taskClosed: 'Zamknięte',
  taskAll: 'Wszystkie',
  taskUnread: 'Nieprzeczytane',
  taskResults: 'Wyniki',
  taskSearchTasks: 'Szukaj zadania lub magazynu',
  taskYou: 'Ty',
  taskAssignedUser: 'Przypisana osoba',
  taskNoTasks: 'Brak zadań w tym widoku',
  taskNoTasksHint: 'Zmień filtry lub utwórz nowe zadanie.',
  taskNoTasksUserHint: 'Zmień filtry lub poczekaj na przypisanie zadania.',
  taskRecurring: 'Zadania cykliczne',
  taskEveryDays: 'Odstęp w dniach',
  taskShowMore: 'Pokaż więcej',
  taskNotificationsHint:
    'Alerty są zgrupowane według magazynu lub zadania. Rozwiń wiersz, aby zobaczyć szczegóły.',
  taskNotificationCount: 'Powiadomienia',
  taskOtherNotifications: 'Pozostałe powiadomienia',
  taskMissingDates: 'Brak terminu',
  taskUpcomingDates: 'Zbliżające się terminy',
  taskOpenStore: 'Otwórz magazyn',
  taskOpenTask: 'Otwórz zadanie',
  taskMarkGroupRead: 'Oznacz grupę jako przeczytaną',
  taskNoNotifications: 'Brak powiadomień do sprawdzenia',
  taskNoNotificationsHint:
    'Jesteś na bieżąco. Odczytane powiadomienia znajdziesz w widoku Wszystkie.',
  taskPushSettings: 'Powiadomienia na tym urządzeniu',
  taskPushHint:
    'Zarządzaj powiadomieniami push dla tej przeglądarki lub urządzenia.',
  taskPushDisabled: 'Powiadomienia push na tym urządzeniu są wyłączone.',
  taskAlertSettings: 'Progi alertów magazynowych',
  taskThresholdHint:
    'Liczba dni przed terminem, oddzielona przecinkami, np. 90,30,7.',
  taskDetails: 'Szczegóły zadania',
  taskFormHint:
    'Wybierz rodzaj zadania, magazyn i osobę odpowiedzialną. Dla remanentu określ też zakres.',
  taskDescriptionOptional: 'Opis (opcjonalnie)',
  taskSchedule: 'Termin i odpowiedzialność',
  taskRepeat: 'Powtarzaj zadanie',
  taskRepeatHint: 'Twórz kolejne zadanie po wykonaniu poprzedniego.',
  taskRecurringHint:
    'Odstęp liczymy od zakończenia. Każde wystąpienie jest przypisywane osobno.',
  taskWholeStore: 'Cały magazyn',
  taskSelectedCategories: 'Wybrane kategorie',
  taskWholeStoreHint:
    'Spis obejmie wszystkie produkty w tym magazynie, również ze stanem zerowym.',
  taskCategoryHint:
    'Wybór kategorii obejmuje jej podkategorie. Wiersze z ikoną połączenia są już uwzględnione.',
  taskSearchCategories: 'Szukaj kategorii',
  taskScopeCount: 'Wybrane gałęzie',
  taskCreate: 'Utwórz zadanie',
  taskCreated: 'Zadanie zostało utworzone.',
  taskStoreRequired: 'Wybierz magazyn dla tego zadania.',
  taskTitleRequired: 'Podaj tytuł zadania.',
  taskDueRequired: 'Podaj prawidłowy termin wykonania.',
  taskIntervalInvalid: 'Podaj całkowitą liczbę dni od 1 do 3650.',
  taskScopeRequired: 'Wybierz co najmniej jedną kategorię albo cały magazyn.',
  taskAssigneeRequired: 'Wybierz osobę uprawnioną do wykonania zadania.',
  taskChooseAssignee: 'Wybierz osobę',
  taskPerformCount: 'Wykonaj remanent',
  taskWizardHintShort:
    'Otwórz kreator ewidencji dla magazynu i zakresu tego zadania.',
  taskManagement: 'Zarządzanie zadaniem',
  taskSaveDate: 'Zapisz termin',
  taskCancelHint: 'Anulować to zadanie? Nie będzie już dostępne do wykonania.',
  taskClosedHint: 'To zadanie jest zamknięte.',
  year: 'Rok',
  month: 'Miesiąc',
  unknownDates: 'Nieznane',
  addDate: 'Dodaj termin',
  monthEnd: 'Termin obowiązuje do ostatniego dnia wybranego miesiąca.',
  increase: 'Zwiększ',
  decrease: 'Zmniejsz',
  showDates: 'Rozwiń ilości według terminów',
  hideDates: 'Zwiń ilości według terminów',
  expirySetting: 'Termin ważności',
  categoryTrackingHint:
    'Dotyczy wszystkich podkategorii i produktów, także dodanych później.',
  inheritedTracking: 'Włączone przez kategorię nadrzędną.',
  reviewSetting: 'Termin przeglądu',
  searchCaretakers: 'Szukaj opiekunów magazynu',
  pushConfigMissing:
    'Push web nie jest skonfigurowany. Administrator musi ustawić klucz VAPID.',
  pushPermissionTimeout:
    'Przeglądarka nie zakończyła pytania o zgodę. Sprawdź ustawienia powiadomień i spróbuj ponownie.',
  pushWorkerTimeout:
    'Nie udało się uruchomić workera powiadomień. Odśwież aplikację, sprawdź połączenie i spróbuj ponownie.',
  pushTokenTimeout:
    'Firebase nie zwrócił tokenu push w wymaganym czasie. Sprawdź połączenie i spróbuj ponownie.',
  pushSaveTimeout: 'Nie zakończono zapisu urządzenia. Spróbuj ponownie.',
  pushEnabled: 'Powiadomienia push są włączone w tej przeglądarce.',
  pushProgress_permission: 'Oczekiwanie na zgodę przeglądarki…',
  pushProgress_worker: 'Przygotowywanie workera powiadomień…',
  pushProgress_token: 'Rejestracja w Firebase Messaging…',
  pushProgress_saving: 'Zapisywanie ustawień powiadomień…',
  nearestDate: 'Najbliższy zapisany termin',
  datesAndBatches: 'Terminy i partie',
  theoretical:
    'Ilości według terminów są teoretyczne. Potwierdź stan fizyczny podczas remanentu.',
  clearDate: 'Wyczyść datę (nieznana)',
  removeBatch: 'Usuń partię',
  fefoHint:
    'Automatyczny pobór rozlicza najpierw nieznane terminy, potem najwcześniejsze terminy ważności/przeglądu. Wskaż rzeczywiste ilości, jeśli pobierasz inne.',
  countInWizard: 'Remanent / popraw daty w kreatorze',
  batchTotalMismatch:
    'Suma ilości partii musi odpowiadać ilości produktu. Rozwiń Terminy i partie i popraw spis.',
  taskWizardHint:
    'Remanent z zadania: zweryfikuj każdy produkt w zleconym zakresie.',
  storeDateSettings: 'Alerty terminów i opiekunowie magazynu',
  trackingHint:
    'Śledzenie terminów dotyczy tego produktu we wszystkich magazynach.',
  date: 'Data operacji',
  time: 'Godzina',
  actionNumber: 'Numer akcji',
  actionRequired:
    'Dla tego sprzętu wymagany jest numer akcji w formacie INT/INT/INT.',
  onlyMine: 'Tylko moje zadania',
  daysSince: 'Dni od wykonania',
  reissue: 'Zleć ponownie',
  batchManaged: 'Szczegóły partii są dostępne w kreatorze ewidencji.',
  type: 'Typ',
  mode: 'Wybór partii',
  title: 'Zadania',
  tasks: 'Zadania',
  batches: 'Partie',
  notifications: 'Powiadomienia',
  settings: 'Ustawienia',
  newTask: 'Nowe zadanie',
  titleLabel: 'Tytuł',
  description: 'Opis',
  store: 'Magazyn',
  assignee: 'Wykonawca',
  unassigned: 'Nieprzypisane',
  assigned: 'Przypisane',
  in_progress: 'W realizacji',
  completed: 'Zakończone',
  cancelled: 'Anulowane',
  stocktaking: 'Remanent',
  general: 'Ogólne',
  dueOn: 'Termin realizacji',
  interval: 'Powtórz po wykonaniu (dni; 0 = jednorazowe)',
  scope: 'Kategorie',
  allCategories: 'Cały magazyn',
  result: 'Wynik / uzasadnienie',
  start: 'Rozpocznij',
  complete: 'Zakończ',
  assign: 'Przypisz',
  cancelTask: 'Anuluj zadanie',
  refreshCount: 'Sprawdź konflikty',
  saveDraft: 'Zapisz szkic',
  checked: 'Zweryfikowano',
  quantity: 'Ilość',
  expiresOn: 'Data ważności',
  reviewOn: 'Termin przeglądu',
  addBatch: 'Dodaj partię',
  unknown: 'Nieznana partia',
  fefo: 'FEFO',
  manual: 'Wybierz partie',
  take: 'Pobranie',
  add: 'Przyjęcie',
  transfer: 'Transfer',
  withdraw: 'Wycofanie',
  equipment: 'Sprzęt',
  destination: 'Magazyn docelowy',
  newMovement: 'Operacja magazynowa',
  save: 'Zapisz',
  close: 'Zamknij',
  refresh: 'Odśwież',
  error: 'Operacja nieudana',
  empty: 'Brak wpisów',
  loading: 'Ładowanie',
  overdue: 'Po terminie',
  unresolved: 'Ilość nierozliczona',
  addUnknownDates: 'Dodaj ilość bez terminu',
  unknownWarning:
    'Nieznana partia: ilości według dat ważności pozostaną niepewne.',
  correct: 'Popraw terminy',
  resolve: 'Rozlicz rozchód',
  initialize: 'Uruchom partie',
  preview: 'Sprawdź migrację',
  legacy: 'Dotychczasowe stany',
  migrationReady: 'Kontrola migracji zakończona pomyślnie',
  confirmMigration: 'Utworzyć partie z dotychczasowych stanów?',
  caretakers: 'Opiekunowie magazynu',
  thresholds: 'Progi alertów (dni, rozdzielone przecinkiem)',
  trackingExpiry: 'Śledź daty ważności',
  trackingReview: 'Śledź terminy przeglądów',
  enablePush: 'Włącz push',
  disablePush: 'Wyłącz push',
  markRead: 'Oznacz jako przeczytane',
  read: 'Przeczytane',
  active: 'Aktywne',
  lastCompleted: 'Ostatnia realizacja',
  nextDue: 'Następny termin',
  never: 'Nigdy',
  disableTemplate: 'Wyłącz powtarzanie',
  noAccess: 'Brak dostępu',
  conflict:
    'Stan zmienił się. Zamknij i ponownie otwórz remanent, a następnie sprawdź pozycje ponownie.',
  checkAll: 'Zweryfikuj każdą pozycję przed zakończeniem.',
  saved: 'Zapisano',
  missing: 'Uzupełnij wymagane pola.',
  split:
    'Zakres jest zbyt duży. Podziel go na zadania dla mniejszych kategorii.',
  pushDenied: 'Brak zgody na push lub konfiguracji platformy.',
  reasonRequired: 'Wymagany jest wynik / uzasadnienie.',
  selectBatch: 'Wybierz partie lub rozchód bez znanej partii.',
  initializeFirst:
    'Administrator musi najpierw uruchomić partie dla tego magazynu.',
  stockLow: 'Niewystarczający stan.',
  draftsWarning:
    'Odświeżenie zachowuje niezmienione wiersze i cofa weryfikację zmienionych stanów.',
};
export const operationsTranslations = { pl, en };
